module.exports = __webpack_public_path__ + "static/media/All That Matters.e21db79b.jpg";